<template>
  <div>
<!--     <head-nav :menuItems="menuItems" /> -->


        <welcome-homepage />
        <section class="gen-list">
          <div class="container">
            <div class="gs-head">
              <h2>Latest Content</h2>
<!--               <a href="" class="lnk-list">see all</a> -->
            </div>
            <ul class="gen-list-content">
              <li v-for="item in items" :class="{vid: item.media && item.media.store.id!=1, multi: item.allVideos.length}">
                <div class="preview">
                  <img v-if="item.media && mediaUrl(item.media).indexOf('pdf')==-1" :src="mediaUrl(item.media, item)" />
                  <span class="video"></span>
                  <span class="cat">{{ item.type && item.type.title }}</span>
                  <span class="stat">{{ "" }}</span>
                </div>
                <div class="desc">
                  <h5><a href="">
                    <em v-if="item.parent?item.parent.subtitle:item.subtitle">{{ item.parent?item.parent.subtitle:item.subtitle }}</em>
                    <span v-html="formatTitle(item.title)"></span>
                  </a></h5>
                  <ul class="related" v-if="item.allVideos.length">
                    <template v-for="(relVideo, ri) in item.allVideos">
                      <li v-if="ri<3">{{ relVideo.title }}</li>
                      <li v-else-if="ri==3">and {{ item.allVideos.length-3 }} more...</li>
                    </template>
                  </ul>
                  <p v-else>{{ introText(item) }}</p>
                  <date>{{ formatDate(item.created, "MMM Do, YYYY") }}</date>
                </div>
                <div class="payment" v-for="payment in [paymentForVideo(item.id)]" v-if="payment">
                  <p class="subscribed">
                    <span>Expires:</span>
                    <em>{{ formatDate(payment.endDate, "MMM Do YYYY") }}</em>
                  </p>
                </div>
                <router-link :to="{name: 'content', params: {id: item.id}}" class="wlink"></router-link>
              </li>
              <li v-for="item in items2" :class="{vid: item.media && item.media.store.id!=1, multi: item.allVideos.length}">
                <div class="preview">
                  <img v-if="item.media && mediaUrl(item.media).indexOf('pdf')==-1" :src="mediaUrl(item.media, item)" />
                  <span class="video"></span>
                  <span class="cat">{{ item.type && item.type.title }}</span>
                  <span class="stat">{{ "" }}</span>
                </div>
                <div class="desc">
                  <h5><a href="" v-html="formatTitle(item.title)"></a></h5>
                  <ul class="related" v-if="item.allVideos.length">
                    <template v-for="(relVideo, ri) in item.allVideos">
                      <li v-if="ri<3">{{ relVideo.title }}</li>
                      <li v-else-if="ri==3">and {{ item.allVideos.length-3 }} more...</li>
                    </template>
                  </ul>
                  <p v-else>{{ introText(item) }}</p>
                  <date>{{ formatDate(item.created, "MMM Do, YYYY") }}</date>
                </div>
                <div class="payment" v-for="payment in [paymentForVideo(item.id)]" v-if="payment">
                  <p class="subscribed">
                    <span>Expires:</span>
                    <em>{{ formatDate(payment.endDate, "MMM Do YYYY") }}</em>
                  </p>
                </div>
                <router-link :to="{name: 'content', params: {id: item.id}}" class="wlink"></router-link>
              </li>
            </ul>
            <div class="load-more" v-if="items.length && !all">
              <a href="" v-on:click.prevent="loadAll">Show all videos</a>
            </div>
          </div>
        </section>

  </div>
</template>
<script>
import api from './api';
import moment from 'moment';
import mainNav from './mainNav';
import dateLimit from './dateLimit';
import formatters from './formatters';
import payment from './payment';

export default {
  mixins: [mainNav, dateLimit, formatters, payment],
  data: ()=>({
    items: [],
    items2: [],
    categories: [],
    latestItems: [],
    searchTerm: '',
    languages: {
      'English': "en",
      'French': "fr",
      'German': "de",
      'Turkish': "tr",
      'Japanese': "jp",
      'Spanish': "sp",
      'Portuguese': "pt",
      'Russian': "ru",
    },
    all: false,
  }),
  methods: {
    widClass(type, item) {
      var suffix="";
      if (this.$route.name=='group')
        return "hl-wid ww1 wh1x wt-details wt0ex";
      return "hl-wid ww1 wh1 wt0"+suffix;
    },
    async loadItems() {
      this.categories=(await api.list("VideoType", {})).items;
//       var q={type: 2};
      var q={};
      if (!appRoot.loggedIn || !appRoot.loggedIn.hasPpatt) {
        q.password='null'
        var ppattCategories=["4"];
        for(var catg of this.categories) {
          if (ppattCategories.find((a)=>a==catg.parent))
            ppattCategories.push(catg.id);
        }
        q.type=["FIND_IN_SET(base.type, '"+(ppattCategories.join(","))+"')=", 0, ""];
        
      }
      var items=(await api.list("Video", q, ["id:DESC"], 48)).items;
      items.sort((a,b)=>{
        if (a.created<b.created) return 1;
        if (a.created>b.created) return -1;
        return 0;
      });
      var usedGroups={};
      var items2=[];
      for(var item of items) {
        if (!usedGroups[item.parent?item.parent.id:item.id]) {
          usedGroups[item.parent?item.parent.id:item.id]=true;
          items2.push(item);
        }
        if (items2.length>=8)
          break;
      }
      this.items=items2;
    },
    async loadAll() {
      this.all=true;
      var usedGroups={};
      var items=(await api.list("Video", {}, ["id:DESC"], 5000)).items;
      var items2=[];
      for(var item of items) {
        if (!usedGroups[item.parent?item.parent.id:item.id]) {
          usedGroups[item.parent?item.parent.id:item.id]=true;
          items2.push(item);
        }
      }
      this.items=items2;
    },
    async loadItems2() {
//       var q={type: 1};
//       var items=(await api.list("Video", q, ["id:DESC"], 4)).items;
//       items.sort((a,b)=>{
//         if (a.created<b.created) return 1;
//         if (a.created>b.created) return -1;
//         return 0;
//       });
//       this.items2=items;
    },
    async loadLatestPerCat() {
      var latestPromises=this.categories.map((a)=>api.list("Video", {type: a.id}, ["created:DESC"], 1));
      var latestResult=await Promise.all(latestPromises);
      for(var res of latestResult)
        if (res.items && res.items.length)
          this.latestItems.push(res.items[0]);
    },
    mediaUrl(obj, item) {
      if (item && item.thumbnail) {
        var media=item.thumbnail;
        if (!media || !media.store || media.store.plugin!="Local")
          return null;
        return media.store.rootUrl+media.path;
      }
      if (!obj)
        return null;
      var rootUrl="";
      if (obj.store && obj.store.rootUrl)
        rootUrl=obj.store.rootUrl;
       if (obj.store.plugin=='Video2')
        return obj.thumbnail;
      else if (obj.thumbnail && obj.store.plugin!="Local")
        return rootUrl+obj.path.replace(/\/[^/]*$/, "/")+obj.thumbnail;
      else
        return rootUrl+obj.path;
    },
    introText(item) {
      var text=[];
      var blocks=(item.blocks || []).slice().sort((a,b)=>{
        if (a.order_index<b.order_index) return -1;
        if (a.order_index>b.order_index) return 1;
        return 0;
      });
      for(var block of blocks) {
        text.push(block.content);
      }
      text=text.map((a)=>a.replace(/\<[^>]*\>/g, "").replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, "\"").replace(/&[a-z]+;/g, ""));
      return text.join(" ").substring(0, 180);
    },
    formatDate(date, format) {
      return moment(date, "YYYY-MM-DD HH:mm:ss").format(format);
    },
  },
  mounted() {
    this.loadItems();
    this.loadItems2();
    this.loadTags();
    if (this.$route.params.category===undefined)
      this.menuItems[0].active=true;
    else if (this.$route.params.category==="webinars")
      this.menuItems[1].active=true;
    else if (this.$route.params.category==="classes")
      this.menuItems[2].active=true;
  },
}
</script>
